import React from 'react';
import BaseChart from '../BaseChart/BaseChart';
import * as ChartPieStyle from './ChartPieStyle';
import { ChartPieProps } from 'types/Chart';
import { useAppSelector } from '../../../redux/hooks';

const ChartPie: React.FC<ChartPieProps> = (props) => {

  const { details, ariaLabel } = props;
  const {isContrast} = useAppSelector(state => state.general);

  const data = {
    labels: details.labels,
    datasets: [{
      data: details.data,
      backgroundColor: details.dataSetColors
    }],
  };

  const options = {
    ...ChartPieStyle.chartOptions(props, isContrast)
  };
  return (
    <BaseChart
      chartType="doughnut"
      data={data}
      options={options}
      plugins={[ChartPieStyle.centerTextSetting]}
      ariaLabel={ariaLabel}
    />
  );
};

export default ChartPie;
